import { applySnapshot, cast, getSnapshot, types } from 'mobx-state-tree';
const Teammember = types.model({
  accountId: types.string,
  email: types.maybeNull(types.string),
  newEmail: types.maybeNull(types.string),
  firstName: types.string,
  id: types.string,
  lastName: types.string,
  phone: types.maybeNull(types.string),
  userRole: types.string,
  username: types.string,
  emailConfirmed: types.boolean,
  isEnabled: types.boolean
});
const ContactUnit = types.model({
  id: types.string,
  firstName: types.string,
  lastName: types.string,
  userRole: types.string,
  email: types.maybeNull(types.string),
  newEemail: types.maybeNull(types.string),
  emailConfirmed: types.boolean
});
const NewTeamMember = types.model({
  firstName: types.string,
  lastName: types.string,
  email: types.string,
  phone: types.string
});
export const NewTeamMemberInitialData = {
  firstName: '',
  lastName: '',
  email: '',
  phone: ''
};
export const ContactInformation = types.model({
  teammembers: types.optional(types.array(Teammember), []),
  selectBuildingContacts: types.optional(types.array(ContactUnit), []),
  selectUtilitiesContacts: types.optional(types.array(ContactUnit), []),
  notSavedNewBuildingTeamMember: types.optional(NewTeamMember, NewTeamMemberInitialData),
  notSavedNewUnitTeamMember: types.optional(NewTeamMember, NewTeamMemberInitialData)
}).actions(store => {
  let afterLoadState;
  return {
    initAfterLoadState() {
      try {
        afterLoadState = getSnapshot(store);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    applyAfterLoadState() {
      try {
        applySnapshot(store, afterLoadState);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    resetContactInformation() {
      try {
        store.selectBuildingContacts = cast([]);
        store.selectUtilitiesContacts = cast([]);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    changeNotSavedNewBuildingTeamMember(field, data) {
      try {
        store.notSavedNewBuildingTeamMember[field] = data;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    resetNotSavedNewBuildingTeamMember() {
      try {
        store.notSavedNewBuildingTeamMember = NewTeamMemberInitialData;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    changeNotSavedNewUnitTeamMember(field, data) {
      try {
        store.notSavedNewUnitTeamMember[field] = data;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    resetNotSavedNewUnitTeamMember() {
      try {
        store.notSavedNewUnitTeamMember = NewTeamMemberInitialData;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    clearSelectedBuildingContacts() {
      try {
        store.selectBuildingContacts = cast([]);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    clearSelectedUtilitiesContacts() {
      try {
        store.selectUtilitiesContacts = cast([]);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
});